import {
  rentersPolicyAvailable,
  standaloneRentersStates,
  condoStates,
  policyType,
  lookupsJson
} from '@ourbranch/lookups';
import { brandConfig } from 'brand-config';

// Parse enabled policy types from environment variable
// Format: { F: true, H: true, A: true, C: true, R: true }
const enabledPolicies = JSON.parse(import.meta.env.VITE_AVAILABLE_POLICY_TYPES);

// Check if a policy type option is enabled based on environment config
// For each base type the option contains, that type must be enabled
const isPolicyTypeEnabled = (optionId) =>
  Object.entries(enabledPolicies).some(([type, isEnabled]) => optionId.includes(type) && isEnabled);

const useAvailablePolicies = (state) => {
  if (!state) {
    return [];
  }
  const isRentersAvailable = rentersPolicyAvailable[state];
  const isStandaloneRentersAvailable = standaloneRentersStates[state];
  const isCondoAvailable = condoStates[state];

  return lookupsJson.policyTypes.filter((opt) => {
    // First check if policy type is allowed for this brand
    if (brandConfig.allowedPolicyTypes) {
      if (!brandConfig.allowedPolicyTypes.includes(opt.id)) {
        return false;
      }
    }

    // Then check if policy type is enabled in environment
    if (!isPolicyTypeEnabled(opt.id)) {
      return false;
    }

    // Finally apply state-based availability rules for Condo and Renters
    if (opt.id.includes(policyType.Condo)) {
      return isCondoAvailable;
    }
    if (opt.id === policyType.ARBundle) {
      return isRentersAvailable;
    }
    if (opt.id === policyType.Renters) {
      return isStandaloneRentersAvailable;
    }

    return true;
  });
};

export default useAvailablePolicies;
